/* Source: src/mt-includes/js/src/core/humanize_duration/init.js*/
angular.module('website.core.humanize_duration', []);
